<!-- Icon -->
<span class="ham-icon icon">
    <i class="exclamation-outline-icon"></i>
</span>

<!-- Text -->
<div class="banner-text">
    {{ message }}
</div>

<!-- ← Spacer takes all the remaining space → -->
<div class="flex-spacer"></div>

<!-- “Do not show again” button -->

<ham-button variant="glass" [size]="'xs'" icon="assets/hamIcons/x.svg" (buttonClick)="onDismiss()"> </ham-button>

<!-- “Request Additional Licenses” button -->
<ham-button variant="glass" (buttonClick)="onRequestMore()" outline="true" size="xs">{{
    'aumico_licence_banner_request_more_button' | i18next
}}</ham-button>
